import { Card, Box, Typography } from '@mui/material';
import { AudienceSection } from './AudienceSection';
import { audienceSections } from './audienceContent';


export const AudiencePage = () => {

  return (
    <Card sx={{ p: 4, pt: 8 }}>

      <Box display="flex" maxWidth={'100%'} flexDirection='column' gap={1} justifyContent='center' alignItems='center'>
        <Typography sx={styles.pageTitle} gutterBottom>
          {'Who Can Benefit From My Real Stat?'}
        </Typography>
        <Typography sx={styles.sectionTitle} maxWidth={1400} textAlign='center' gutterBottom>
          {`In today's data-driven world, statistics have become essential across all industries — and real estate is no exception. Traditionally, historical data has been used primarily to estimate current market prices. My Real Stat goes far beyond that. Our platform empowers users to visually explore a wide range of real estate attributes, uncover trends, and gain deeper insights into both current conditions and potential future movements in the market. Whether you're a student exploring business or statistics, an investor assessing property trends, or a professional who needs fast, reliable insights into local markets — My Real Stat is built for you.`}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 4 }}>
        {audienceSections.map((section, index) => (
          <AudienceSection
            key={index}
            index={index}
            image={section.image}
            title={section.title}
            description={section.description}
            position='left'
          />
        ))}
      </Box>
    </Card>
  );
};

const styles = {
  pageTitle: { typography: 'h3', },
  sectionTitle: { typography: 'h6', },
  sectionBody: {
    typography: 'h6',
    mb: 2,
    mt: 0,
  }
};